import { t } from '@lingui/macro';
import * as yup from 'yup';
const nameMessage = t({
    message: 'Name is required',
    comment: 'Error message when name is empty',
});
export const updateTeamSchema = yup.object().shape({
    name: yup.string().required(nameMessage),
    description: yup.string(),
});
